import type { CustomerDisplayPoster } from "@/services/setting";

export const DEFAULT_CUSTOMER_DISPLAY_POSTERS: CustomerDisplayPoster[] = [
  {
    image: "storage/settings/customer-display/fresh-chicken-daily.jpg",
    caption: "មាន់ស្រស់ និងសាច់ក្លាសេថ្មីរាល់ថ្ងៃ - Fresh chicken daily",
    title: "មាន់ស្រស់ និងសាច់ក្លាសេថ្មីរាល់ថ្ងៃ - Fresh chicken daily",
    text: "Fresh chicken daily",
  },
  {
    image: "storage/settings/customer-display/seasoning-essentials.jpg",
    caption: "គ្រឿងផ្សំសម្រាប់ម្ហូបមាន់ - Seasoning essentials for chicken",
    title: "គ្រឿងផ្សំសម្រាប់ម្ហូបមាន់ - Seasoning essentials for chicken",
    text: "Seasoning essentials for chicken",
  },
  {
    image: "storage/settings/customer-display/daily-shop-essentials.jpg",
    caption: "ទឹកសុទ្ធ និងទំនិញប្រើប្រចាំថ្ងៃ - Daily shop essentials",
    title: "ទឹកសុទ្ធ និងទំនិញប្រើប្រចាំថ្ងៃ - Daily shop essentials",
    text: "Daily shop essentials",
  },
];

const normalizeCustomerDisplayPoster = (
  input: unknown,
  fallback: CustomerDisplayPoster
): CustomerDisplayPoster => {
  const value =
    typeof input === "object" && input !== null
      ? (input as Partial<CustomerDisplayPoster>)
      : {};

  const image = String(value.image || "").trim();
  const caption = String(
    value.caption ||
      (image ? value.title || value.text : "") ||
      fallback.caption ||
      fallback.title ||
      fallback.text ||
      ""
  ).trim();

  return {
    image: image || String(fallback.image || "").trim(),
    caption,
    eyebrow: String(value.eyebrow || fallback.eyebrow || "").trim(),
    title: String(value.title || caption || fallback.title || "").trim(),
    text: String(value.text || fallback.text || caption || "").trim(),
    price: String(value.price || fallback.price || "").trim(),
    tag: String(value.tag || fallback.tag || "").trim(),
  };
};

export const normalizeCustomerDisplayPosters = (
  input?: unknown
): CustomerDisplayPoster[] => {
  let parsed: unknown = input;

  if (typeof input === "string") {
    try {
      parsed = JSON.parse(input);
    } catch {
      parsed = null;
    }
  }

  const items = Array.isArray(parsed) ? parsed : [];
  const normalized = DEFAULT_CUSTOMER_DISPLAY_POSTERS.map((fallback, index) =>
    normalizeCustomerDisplayPoster(items[index], fallback)
  );

  return normalized.length ? normalized : [...DEFAULT_CUSTOMER_DISPLAY_POSTERS];
};
